// Replaces origin html: <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/grd/1.2.3/grd.css">
export const grdCss = `.Grid{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.Grid.\-top{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.Grid.\-middle{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.Grid.\-bottom{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.Grid.\-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;-ms-grid-row-align:stretch;align-items:stretch}.Grid.\-baseline{-webkit-box-align:baseline;-webkit-align-items:baseline;-ms-flex-align:baseline;-ms-grid-row-align:baseline;align-items:baseline}.Grid.\-left{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.Grid.\-center{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.Grid.\-right{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.Grid.\-between{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.Grid.\-around{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.Cell{box-sizing:border-box;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}.Cell.\-fill{width:0;min-width:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.Cell.\-1of12{width:calc(100%*1/12)}.Cell.\-2of12{width:calc(100%*2/12)}.Cell.\-3of12{width:calc(100%*3/12)}.Cell.\-4of12{width:calc(100%*4/12)}.Cell.\-5of12{width:calc(100%*5/12)}.Cell.\-6of12{width:calc(100%*6/12)}.Cell.\-7of12{width:calc(100%*7/12)}.Cell.\-8of12{width:calc(100%*8/12)}.Cell.\-9of12{width:calc(100%*9/12)}.Cell.\-10of12{width:calc(100%*10/12)}.Cell.\-11of12{width:calc(100%*11/12)}.Cell.\-12of12{width:100%}`;

const exportCss = `
h2 {
  clear: both;
  display: block;
  /* page-break-before: always; */
}

h3 {    
  margin-bottom: 10px;
}

p {
  white-space: pre-line;
  margin-top: 0;
  margin-bottom: 0;
}

table {
  border: 1px solid #000;
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
}

table.matrix {
  table-layout: fixed;
}

tr, td {
  page-break-inside: avoid;
  border: 1px solid;
  font-size: 14px;
}

.single td {
  width: 55%;
  padding: 8px;
  background-color: #f3f3f3;
  border: 1px solid #000;
  vertical-align: top;
}

.single td:first-child, .matrix th {
  background-color: #b7dde8;
  font-weight: bold;
  /* font-weight: 700; */
}

td.empty {
  background: #eee;
  font-weight: bold;
  padding: 10px;
  text-align: center;
}

tr.note-row, tr.note-row td.note-column {
  background-color: lightyellow;
  font-family: Courier;
  font-weight: lighter;
  padding: 0;
  margin: 0;
}
.note-label {
  float: left;
  padding: 3px 5px;
  margin-right: 5px;
  background-color: yellow;
}
.note-details {
  padding: 3px 5px 0 3px;
  color: #31708f;
  background-color: #d9edf7;
}
.note-datetime,
.note-author {
  color: #777;
}
.note-datetime {
  float: right;
}
.note-text {
  clear: both;
  overflow: hidden;
  width: 100%;
  padding: 3px;
  color: #3C2611;
  background-color: #FCF8E3;
}

.break {
  page-break-before: avoid;
}

.must-break {
  page-break-before: always;
}

.answerBlock {
  display: table;
}

.answerBlock.centered {
  display: table;
  margin: 0 auto;
}

.answerBlock .answerCell {
  display: table-cell; 
}
  
.answerBlock .answerCell.one {
  width: 15px;
}
  
.answerBlock .answerCell .pendingAsterisk {
  color: #e5a50b;
  font-size: 32px;
  overflow: hidden;
  height: 15px;
  padding-bottom: 5px;
  display: inline-block;  
  }

.answerBlock .answerCell .strikeThru { 
  text-decoration: line-through;  
}

.export-table .generic-table {
  table-layout: fixed;
}
`;

export default exportCss;
